import { IModelSpecification } from "./model-specification.interface";
import { ServiceType } from "./service-type.interface";

export interface IDefaultService {
  id: number;
  name: string;
  displayToCustomers: boolean;
  prevMaintenance: boolean; // Quando isso é true, significa que é revisão
  revisionCode: number;
  months: number;
  active: boolean;
  dmsCode: string;
  country: string;
  serviceId: number;
  serviceName: string;
  serviceType: ServiceType;
  servicesByModelGroup: IDefaultService[];
  model: IModelSpecification;
  serviceTypeId: number;
  servicePrice: number;
  kmFrom: number;
  kmTo: number;
  fixedPrice: boolean;
  isCostless: boolean;
  promotionalPrice: number;
  promotionalDescription: string;
  promotionalStartDate: Date;
  promotionalEndDate: Date;
  promotionalStartTime: Date;
  promotionalEndTime: Date;
  promotionalPriceDealer: number;
  promotionalStartHour: string;
  promotionalEndHour: string;
  promotionalActive: boolean;
  servicePriceDealer: number;
  costless: boolean;
  msvApplicable: boolean;
  isSelected?: boolean;
  duration: number;
  priceFixed: boolean;

  //comment scope
  displayComment: boolean;
}
